import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Grid2 from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { pathOr } from 'ramda'
import React from 'react'

import { Select } from '@/app/component/atom/form'
import { DEFAULT_SENDER_ID_NAME, DEFAULT_SENDER_ID_VALUE } from '@/app/definitions'
import { SenderIdsForDripType } from '@/app/module/campaigns/helpers'
import { SenderIdOption, SMSBlastCampaignItem } from '@/app/module/campaigns/types'

type Messages = {
  senderIds: SenderIdOption[]
  senderIdsForDrip: SenderIdsForDripType
  whatsappSenderIds: SenderIdOption[]
}

type Props = {
  item: SMSBlastCampaignItem
  messages: Messages
  onChange: (item: Partial<SMSBlastCampaignItem>) => void
}

const PhoneNumberSMSBlast: React.FC<Props> = ({ item, messages, onChange }) => {
  const senderIDInfo =
    "Contact support to register your own branded sender ID so SMS come from your organization's name"

  const senderIds = pathOr([], ['senderIds'], messages)
  const senderIdValues = [
    {
      label: DEFAULT_SENDER_ID_NAME,
      value: DEFAULT_SENDER_ID_VALUE,
      type: 'sender',
    },
    ...senderIds,
  ]

  const handleChange = ({ value }: { value: string }) => {
    const isDefaultSenderId = value === DEFAULT_SENDER_ID_VALUE

    onChange({
      ...item,
      variables: {
        ...item.variables,
        defaultSenderId: isDefaultSenderId,
        senderId: isDefaultSenderId ? '' : value,
      },
    })
  }

  const defaultSenderId = pathOr(false, ['variables', 'defaultSenderId'], item)
  const senderId = React.useMemo(() => {
    if (defaultSenderId) {
      return DEFAULT_SENDER_ID_VALUE
    }
    return pathOr('', ['variables', 'senderId'], item)
  }, [defaultSenderId, item])

  return (
    <Card style={{ marginBottom: '2rem' }}>
      <CardHeader title="Sender ID" style={{ padding: '12px 24px' }} />
      <CardContent>
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="body1" gutterBottom={true}>
              Select what should appear on Contacts phones as whom the SMS Message is from (e.g., MyOrg or 12125551212)
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 12 }}>
            <Grid2 container spacing={1}>
              <Grid2 size={{ xs: 5 }}>
                <Typography variant="body1" gutterBottom={false} style={{ padding: '6px 10 7px' }}>
                  Sender ID
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 4 }}>
                <Select
                  name="senderid"
                  id="campaign-item-senderid"
                  data-testid="campaign-item-senderid"
                  editable
                  error={senderId ? '' : 'You must select a sender ID.'}
                  info={!senderIds.length ? senderIDInfo : undefined}
                  label={undefined}
                  value={senderId}
                  values={senderIdValues}
                  onChange={handleChange}
                />
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  )
}

export default PhoneNumberSMSBlast
